<template>
  <v-container
    id="approval"
    class="approval-group"
  >
    <v-progress-linear
      v-show="loading"
      indeterminate
      color="primary"
    />
    <div
      v-show="!loading"
    >
      <div class="text-center display-1 mt-6">
        {{ approvalTypeTitle }} Approvals
      </div>
      <v-container fluid>
        <v-row dense>
          <v-col
            v-for="(approvalType, i) in approvals.approvalTypes"
            :key="i"
          >
            <v-card
              class="approval-box"
              :class="{ approved: approvals[approvalType].id, 'not-approved': !approvals[approvalType].id }"
            >
              <v-card-text>
                <div class="display-2 text--primary">
                  <v-avatar
                    v-show="!approvals[approvalType].id"
                    color="red"
                  >
                    <v-icon dark>
                      mdi-account-cancel
                    </v-icon>
                  </v-avatar>
                  <v-avatar
                    v-show="approvals[approvalType].id"
                    color="green"
                  >
                    <v-avatar>
                      <img :src="avatarImg(approvals[approvalType].email)">
                    </v-avatar>
                  </v-avatar>
                  <span v-text="approvals[approvalType].title" />
                </div>

                <div
                  v-show="!approvals[approvalType].id"
                >
                  <span
                    class="font-weight-medium text--primary"
                  >
                    No Approval Yet
                  </span>
                </div>
                <div
                  v-show="approvals[approvalType].id"
                >
                  <base-display-value
                    v-model="approvals[approvalType].name"
                    label="Approved By"
                    class="mt-2"
                  />
                  <base-display-value
                    v-model="approvals[approvalType].date"
                    label="Approved On"
                  />
                </div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
      <div v-if="showApprovalButtons">
        <v-btn
          text
          color="green"
          @click="approve"
        >
          <v-icon>
            mdi-account-check
          </v-icon>
          Approve
        </v-btn>
        <v-btn
          text
          color="red"
          @click="reject"
        >
          <v-icon>
            mdi-account-check
          </v-icon>
          Reject
        </v-btn>
      </div>
    </div>
    <base-material-snackbar
      v-model="displayError"
      type="error"
      v-bind="{
        top: true,
        right: true
      }"
    >
      {{ errorMessage }}
    </base-material-snackbar>
  </v-container>
</template>

<script>
  import TroodyApi from '@/services/troody/TroodyApi'
  import { mapGetters } from 'vuex'
  import { isBroker } from '@/services/roleValidator'
  import md5 from 'md5'

  export default {
    name: 'Approval',

    props: {
      approvals: {
        type: Object,
        default: null,
      },
      title: {
        type: String,
        default: null,
      },
      allowChange: {
        type: Boolean,
        default: true,
      },
    },

    data: () => ({
      errorMessage: null,
      displayError: false,
      formErrors: {},

      loadingSections: false,
      loadingApproval: false,

      approvalResource: new TroodyApi('oeApproval/'),
    }),

    computed: {
      ...mapGetters('oidcStore', ['oidcUser']),

      loading () {
        return (this.approvals || {}).loading
      },

      approvalTypeTitle () {
        return this.title || ((this.approvals || {}).section || {}).name || ''
      },

      showApprovalButtons () {
        return this.allowChange && isBroker(this.oidcUser)
      },
    },

    created () {
      this.initialize()
    },

    methods: {
      initialize () {
        this.formErrors = {}
        this.loadSection()
      },

      loadSection () {
        this.approvals.loadDetails()
          .then(data => {
            this.approvalDetails = data
          })
          .catch((error) => {
            this.approvalDetails = null
            this.showError(error, 'Failed to load approval details!')
          })
      },

      avatarImg (data) {
        const email = (data || 'unknown@unknown.com')
        const img = [
          '//www.gravatar.com/avatar/',
          md5(email.trim().toLowerCase()),
          '?s=80', // 80 pixels
          '&d=mm', // Default (mystery man)
          '&r=pg', // PG Rating
        ]
        return img.join('')
      },

      setApproval (isApproval) {
        this.approvals.approve(isApproval)
          .then(data => {
            this.approvalDetails = data
            this.$emit('approval:changed')
          })
          .catch((error) => {
            this.approvalDetails = null
            this.showError(error, 'Failed to modify approval!')
          })
      },

      approve () {
        this.setApproval(true)
      },

      reject () {
        this.setApproval(false)
      },

      showError (error, msg) {
        console.log(error)
        this.errorMessage = (error || msg)
        this.displayError = true
      },
    },
  }
</script>

<style lang="sass">
  .approval-box
    border-width: 3px
    border-style: solid
    border-radius: 10px !important
    margin: 4px !important

    &.approved
      border-color: rgba(0, 255, 0, 0.1) !important

    &.not-approved
      border-color: rgba(255, 0, 0, 0.1) !important
</style>
